import { render, staticRenderFns } from "./weekdayHeader.vue?vue&type=template&id=0119aff6&"
import script from "./weekdayHeader.js?vue&type=script&lang=js&"
export * from "./weekdayHeader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0119aff6')) {
      api.createRecord('0119aff6', component.options)
    } else {
      api.reload('0119aff6', component.options)
    }
    module.hot.accept("./weekdayHeader.vue?vue&type=template&id=0119aff6&", function () {
      api.rerender('0119aff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/weekdayHeader.vue"
export default component.exports